import React from "react";

export default function ServiceSectionHead({ section }) {
    return (
        <div className="service-section-head">
            <span className="service-label">{section.label}</span>
            <h2>{section.title}</h2>
            {section.text ? <p>{section.text}</p> : null}
        </div>
    );
}
